import {useSelector} from "react-redux";


function DealerInfo(){

    const dealerBac = useSelector(state => state.dealerReducer.bac);
    const dealerArray = useSelector(state => state.dealerReducer.dealers);

    let dealer = dealerArray.find(dealer => dealer.baccode === dealerBac)
    if((dealerArray.length > 0) && dealerBac) {
        return (
            <>
                <div className={'dealerNameCart'}>
                    {dealer.dealerName}
                </div>
                <div className={'dealerAddressLine1'}>
                    {dealer.street1}
                </div>
                <div className={'dealerAddressLine2'}>
                    {dealer.city + ', ' + dealer.state + ' ' + dealer.zip.substr(0, 5) + '-' + dealer.zip.substr(5)}
                </div>
                <div className={'dealerPhoneCart'}>
                    {dealer.servicePhoneNumber}
                </div>
            </>
        )
    }
    else{
        return null;
    }
}

export default DealerInfo;